export default "__VITE_PUBLIC_ASSET__f76fac38__"